export default {"src":"/_next/static/media/sbp.ba2e13b1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};